import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={49}
    height={65}
    fill="none"
    viewBox="0 0 49 65"
    {...props}
  >
    <path
      stroke="#D9D9D9"
      fill="#FFFFFF"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m7.066 63.284 39.285-27.607c2.199-1.546 2.199-4.824 0-6.37L7.066 1.7C4.523-.086 1 1.753 1 4.87v55.243c0 3.145 3.497 4.984 6.066 3.171Z"
    />
  </svg>
)
export default SvgComponent
